/** Convert 1–10 overall to legacy 0–5 session.rating scale */
export function overallToLegacyRating(overall: number): number {
  return Math.round((overall / 2) * 10) / 10
}

export function getEffectiveSessionRating(session: {
  rating?: number | null
  sessionRating?: { overall?: number } | null
}): number | null {
  if (session.rating != null && session.rating > 0) {
    return session.rating
  }
  const overall = session.sessionRating?.overall
  if (overall != null) {
    return overallToLegacyRating(overall)
  }
  return null
}

export function getSessionDurationMinutes(session: {
  durationMinutes?: number | null
  startTime?: string | null
  endTime?: string | null
}): number | null {
  if (session.durationMinutes != null && session.durationMinutes > 0) {
    return session.durationMinutes
  }
  if (session.startTime && session.endTime) {
    const ms = new Date(session.endTime).getTime() - new Date(session.startTime).getTime()
    if (ms > 0) return Math.round(ms / 60000)
  }
  return null
}

export function formatSessionDuration(minutes: number | null | undefined): string {
  if (!minutes) return 'N/A'
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60
  return hours > 0 ? `${hours}h ${mins}m` : `${mins}m`
}
